import * as _ from 'underscore';

import { SiteRoleOption, UnlicensedTier } from '../../userManagement/services/resources/SiteRoleOptions';

export class SiteRolePickerMenuHelper {

  public static getPickerMenuDropdownOptionDisabledOptions(availableQuota: number, siteRoleOptions: ReadonlyArray<SiteRoleOption>): ReadonlyArray<SiteRoleOption> {
    const disableAllExceptUnlicensed = (option: SiteRoleOption) => availableQuota <= 0 && option.licenseTierRole !== UnlicensedTier;
    return _.filter(siteRoleOptions, disableAllExceptUnlicensed);
  }
}

